/**
 * @ngdoc Filter
 * @name vrmOnlyRawValue
 */

/**
 * @ngdoc Filter
 * @name vrmOnlyFormatUnit
*/

(function() {
    'use strict';

    angular.module('vrm.components')
        .filter('vrmOnlyRawValue', vrmOnlyRawValue)
        .filter('vrmOnlyFormatUnit', vrmOnlyFormatUnit);

    function vrmOnlyRawValue() {
        return function(value) {
            if (!value) return '';
            if (!/\d/.test(value)) return value;
            let parts = value.split(' ');
            parts.pop();
            return parts.join('');
        }
    }

    function vrmOnlyFormatUnit() {
        return function(value) {
            if (!value) return '';
            if (!/\d/.test(value)) return '';
            let parts = value.split(' ');
            return parts.pop();
        }
    }

})();
